module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9oCYw"))).then(() => parcelRequire('d0iPb'));